import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContractError } from 'src/app/core/models/models';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
})
export class ErrorModalComponent {
  @Input() error: ContractError;
  @Output() closeModal = new EventEmitter<boolean>();


}
